import { Component, OnInit, Input, inject } from "@angular/core";
import { DataSubjectModel } from "@app/datamanagement/models/DataSubjectModel";
import { BsModalService } from "ngx-bootstrap/modal";
import { DataStructuresHelper } from "@app/datamanagement/shared/helpers/datastructures-helper";
import { DatamanagementDataService } from "@app/datamanagement/services/datamanagement-data.service";
import { DataStructureModel } from "@app/datamanagement/models/DataStructureModel";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/datamanagement/i18n/scope";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "datasubjects-overview",
    templateUrl: "./datasubjects-overview.component.html",
    styleUrls: ["./datasubjects-overview.component.scss", "../../../../sass/datamanagement.scss"],
    imports: [TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class DataSubjectsOverviewComponent implements OnInit {
    private _modalService = inject(BsModalService);
    private _datamanagementDS = inject(DatamanagementDataService);

    @Input() dataSubjects: DataSubjectModel[];
    @Input() disabled: boolean;

    ngOnInit() {
        this.dataSubjects = this.dataSubjects ? this.dataSubjects : [];

        this.loadDataStructures();
    }

    loadDataStructures() {
        this.dataSubjects.forEach((dataSubject) => {
            if (dataSubject.connectedId) {
                this._datamanagementDS
                    .getDataStructures(dataSubject.connectedId)
                    .subscribe((dataStructures) => {
                        dataSubject.dataStructures = dataStructures.map(
                            (x) =>
                                <DataStructureModel>{
                                    connectedId: x.id,

                                    dataSubjectId: dataSubject.id,
                                    id: x.dataStructureID,
                                    name: x.name,
                                    archivePolicy: x.archivePolicy,
                                }
                        );

                        dataSubject.dataStructuresLoaded = true;
                    });
            }
        });
    }

    viewDataStructures(dataSubject: DataSubjectModel) {
        DataStructuresHelper.viewArchivePolicyDialog(
            dataSubject,
            this._modalService,
            this.disabled
        ).subscribe((dialogResult: DataStructureModel[] | boolean) => {
            if (dialogResult) {
                dataSubject.dataStructures = dialogResult as DataStructureModel[];
            }
        });
    }
}
